import React, { useEffect, useState, useContext } from "react";
import { StockIndicator, LanguageContext } from "@eriksdigital/atomic-ui/components";
import { DeliveryDate, StockIndicatorWrapper } from "./style";
import { FormattedMessage } from "react-intl";

type statusesType = {
  CompletelyOnStock: string;
  NothingOnStock: string;
  Loading: string;
  Unavailable: string;
};

const statuses = {
  CompletelyOnStock: {
    status: "inStock",
    message: (
      <FormattedMessage
        id="stock-info.CompletelyOnStock"
        defaultMessage="In Stock"
        description="Label of Not price in search results section"
      />
    )
  },
  NothingOnStock: {
    status: "outOfStock",
    message: (
      <FormattedMessage
        id="stock-info.NothingOnStock"
        defaultMessage="Out of stock"
        description="Label of out of stock in search results section"
      />
    )
  },
  Loading: {
    status: "loading",
    message: (
      <FormattedMessage
        id="stock-info.loading"
        defaultMessage="Loading stock information"
        description="Label of loading in search results section"
      />
    )
  },
  Unavailable: {
    status: "infoUnavailable",
    message: (
      <FormattedMessage
        id="stock-info.unavailable"
        defaultMessage="Stock information unavailable"
        description="Label of loading in search results section"
      />
    )
  }
};

export const StockInformation = (data: any) => {
  const [status, setStatus] = useState<keyof statusesType>("Loading");
  const [stockLoading, setStockLoading] = useState(true);
  const { erpSystem } = useContext<any>(LanguageContext);

  useEffect(() => {
    if (!!data.data) {
      setStatus(data.data.available);
      setStockLoading(false);
    }
  }, [data]);

  if (!stockLoading && !!data === false) {
    return (
      <StockIndicator
        status={statuses["Unavailable"]?.status}
        stockMessage={statuses["Unavailable"]?.message}
      />
    );
  }
  const shouldShowStockLabel = !(erpSystem === "ch");

  return (
    <>
      <DeliveryDate>
        <FormattedMessage
          id="item.delivery"
          defaultMessage="Delivery on: "
          description="Label of delivery date in search results section"
        />{" "}
        {data.data.deliveryDate}
      </DeliveryDate>
      {status && shouldShowStockLabel && (
        <StockIndicatorWrapper>
          <StockIndicator
            status={statuses[status]?.status}
            stockMessage={statuses[status]?.message}
          />
        </StockIndicatorWrapper>
      )}
    </>
  );
};
